import { computed, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useOrgMembership } from '@/composables/useOrgMembership'

export function useActiveTab() {
  const router = useRouter()
  const route = useRoute()
  const store = useStore()
  const { isOrgMember } = useOrgMembership()

  const orgId = computed(() => parseInt(route.params.org_id))
  const selectedOrgId = computed(() => store.getters['org/getSelected'])

  const activeTab = computed(() => {
    let tab = 'projects'
    if (route.name === 'OrgProjects') {
      tab = 'projects'
    } else if (route.name === 'OrgLayers' || route.name === 'LayerCreate' || route.name === 'LayerDetail') {
      tab = 'layers'
    } else if (route.name === 'OrgReports' || route.name === 'ChatSession') {
      tab = 'chats'
    } else if (route.name === 'OrgReportsPage' || route.name === 'ReportDetail') {
      tab = 'reports'
    } else if (route.name === 'OrgPayments') {
      tab = 'payments'
    }
    if (!isOrgMember.value && (tab === 'layers' || tab === 'chats' || tab === 'reports' || tab === 'payments')) {
      return 'projects'
    }
    return tab
  })

  const orgOnlyTabs = ['layers', 'chats', 'reports', 'payments']
  const isNavigating = ref(false)

  const navigateToTab = async (tab) => {
    if (orgOnlyTabs.includes(tab) && !isOrgMember.value) return
    if (isNavigating.value) return
    isNavigating.value = true

    try {
      const currentOrgId = orgId.value || selectedOrgId.value

      if (!currentOrgId) {
        await store.dispatch('org/fetchOrgs')
        const orgs = store.getters['org/getOrgs']
        if (orgs.length > 0) {
          const firstOrgId = orgs[0].organization_id
          await store.dispatch('org/setSelectedOrg', firstOrgId.toString())

          if (tab === 'projects') {
            await router.push({ name: 'OrgProjects', params: { org_id: firstOrgId } })
          } else if (tab === 'layers') {
            await router.push({ name: 'OrgLayers', params: { org_id: firstOrgId } })
          } else if (tab === 'chats') {
            await router.push({ name: 'OrgReports', params: { org_id: firstOrgId } })
          } else if (tab === 'reports') {
            await router.push({ name: 'OrgReportsPage', params: { org_id: firstOrgId } })
          } else if (tab === 'payments') {
            await router.push({ name: 'OrgPayments', params: { org_id: firstOrgId } })
          }
        }
        return
      }

      if (tab === 'projects') {
        await router.push({ name: 'OrgProjects', params: { org_id: currentOrgId } })
      } else if (tab === 'layers') {
        await router.push({ name: 'OrgLayers', params: { org_id: currentOrgId } })
      } else if (tab === 'chats') {
        await router.push({ name: 'OrgReports', params: { org_id: currentOrgId } })
      } else if (tab === 'reports') {
        await router.push({ name: 'OrgReportsPage', params: { org_id: currentOrgId } })
      } else if (tab === 'payments') {
        await router.push({ name: 'OrgPayments', params: { org_id: currentOrgId } })
      }
    } finally {
      isNavigating.value = false
    }
  }

  return { activeTab, navigateToTab, isNavigating, isOrgMember }
}
